export class Intervals {}

// Interval Keys
Intervals.DAILY = 'daily'
Intervals.DAILY_DATA = 'daily-data'
Intervals.WEEKLY = 'weekly'
Intervals.MONTHLY = 'monthly'
Intervals.SEMI_MONTHLY = 'semi-monthly'

// Interval Options for select2
// the keys for this object match the values of the above constants.
Intervals.INTERVAL_OPTIONS = {
    daily: 'Send Daily (Monthly Data)',
    'daily-data': 'Send Daily (Day\'s Data)',
    weekly: 'Send Weekly',
    'semi-monthly': 'Send Semi-Monthly',
    monthly: 'Send Monthly',
}

// Weekday Options
Intervals.WEEKDAY_OPTIONS = {
    0: "Sunday",
    1: "Monday",
    2: "Tuesday",
    3: "Wednesday",
    4: "Thursday",
    5: "Friday",
    6: "Saturday",
}

// Semi-Month Options
Intervals.SEMI_MONTH_OPTIONS = {
    first: '1st Half (1 - 15)',
    last: '2nd Half (16 - End of Month)',
}
